module.exports = __webpack_public_path__ + "media/images/crosswords/pos2-d2ce68beb80f50dad31fb4ecf8917ba4.png";